import { dealsAPiAdapter } from './deals';
import { customersApiAdapter } from './customers';
import { projectsApiAdapter } from './projects';
import { statusApiAdapter } from './statuses';
import { commentsApi, commentsFilesApi } from './dealsComments';
import { staffCommentFilesApi } from './staffCommentFiles';
import { purchaseInvoiceFilesApi } from './purchaseInvoiceFiles';
import { trackingParcelsApiAdapter } from './trakingParcels';
import { deliverySerivicesApiAdapter } from './deliveryServices';
import { agentsApiAdapter, paymentTypes } from './agents';
import { agentsPaymentsApiAdapter, agetPaymentsApiFiles } from './agentPayments';
import { dealsLogApiAdapter } from './dealsLog';
import { productConflictsApiAdapter } from './productConflicts';
import { basecampApiAdapter } from './basecamp';

export const dealsAPI = {
  ...statusApiAdapter,
  ...trackingParcelsApiAdapter,
  ...dealsAPiAdapter,
  ...agentsPaymentsApiAdapter,
  ...agetPaymentsApiFiles,
  ...commentsApi,
  ...commentsFilesApi,
  ...staffCommentFilesApi,
  ...purchaseInvoiceFilesApi,
  ...customersApiAdapter,
  ...agentsApiAdapter,
  ...paymentTypes,
  ...projectsApiAdapter,
  ...deliverySerivicesApiAdapter,
  ...dealsLogApiAdapter,
  ...productConflictsApiAdapter,
  ...basecampApiAdapter,
};
